var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationProvider", {
    ref: "provider",
    staticClass: "form-group flex flex-col",
    attrs: {
      vid: _vm.name || _vm.label.toLowerCase(),
      name: _vm.label,
      rules: _vm.rules,
      bails: false,
      tag: "div"
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var classes = ref.classes
          var errors = ref.errors
          return [
            _vm.label.length > 0 &&
            _vm.type !== "fileupload" &&
            _vm.type !== "toggle" &&
            _vm.type !== "checkbox" &&
            _vm.type !== "radio"
              ? _c(
                  "label",
                  {
                    class: classes,
                    attrs: {
                      for: "id_" + (_vm.name || _vm.label.toLowerCase())
                    }
                  },
                  [_vm._v(_vm._s(_vm.label))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.description.length > 0 && _vm.type !== "fileupload"
              ? _c(
                  "small",
                  {
                    staticClass: "font-light",
                    attrs: {
                      id: "description_" + (_vm.name || _vm.label.toLowerCase())
                    }
                  },
                  [_vm._v(_vm._s(_vm.description))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "textarea"
              ? _c(
                  "textarea",
                  _vm._g(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localValue,
                          expression: "localValue"
                        }
                      ],
                      staticClass: "text-black",
                      class: classes,
                      attrs: {
                        id: "id_" + (_vm.name || _vm.label.toLowerCase()),
                        "aria-describedby":
                          "description_" +
                          (_vm.name || _vm.label.toLowerCase()),
                        placeholder: _vm.placeholder || "" + _vm.label,
                        cols: "3"
                      },
                      domProps: { value: _vm.localValue },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.localValue = $event.target.value
                        }
                      }
                    },
                    Object.assign({}, _vm.$listeners, { input: _vm.update })
                  )
                )
              : _vm.type === "fileupload"
              ? _c(
                  "div",
                  { staticClass: "fileupload" },
                  [
                    _c("span", { staticClass: "label", class: classes }, [
                      _vm._v(_vm._s(_vm.label))
                    ]),
                    _vm._v(" "),
                    _vm.description.length > 0
                      ? _c(
                          "small",
                          {
                            staticClass: "font-light",
                            attrs: {
                              id:
                                "description_" +
                                (_vm.name || _vm.label.toLowerCase())
                            }
                          },
                          [_vm._v(_vm._s(_vm.description))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("label", {
                      staticClass: "d-block file-input",
                      attrs: { id: "drop-area", for: "fileinput" },
                      domProps: { innerHTML: _vm._s(_vm.placeholder) }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      ref: "fileinput",
                      attrs: {
                        type: "file",
                        id: "fileinput",
                        multiple: { multiple: _vm.multiple },
                        accept: _vm.inputAccept
                      },
                      on: {
                        change: function($event) {
                          return _vm.handleFileUpload()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm._l(Array.from(_vm.localValue), function(file, index) {
                      return _c(
                        "span",
                        {
                          key: index,
                          staticClass: "filename",
                          on: {
                            click: function($event) {
                              return _vm.clearUpload(file.name)
                            }
                          }
                        },
                        [_vm._v(_vm._s(file.name))]
                      )
                    })
                  ],
                  2
                )
              : _vm.type === "toggle"
              ? _c("div", { staticClass: "toggle" }, [
                  _c(
                    "span",
                    { staticClass: "label", class: _vm.labelClasses },
                    [_vm._v(_vm._s(_vm.label))]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.localValue,
                        expression: "localValue"
                      }
                    ],
                    attrs: {
                      type: "checkbox",
                      id: "id_" + (_vm.name || _vm.label.toLowerCase())
                    },
                    domProps: {
                      checked: Array.isArray(_vm.localValue)
                        ? _vm._i(_vm.localValue, null) > -1
                        : _vm.localValue
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.localValue,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.localValue = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.localValue = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.localValue = $$c
                          }
                        },
                        _vm.update
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { attrs: { for: "toggle" }, on: { click: _vm.toggle } },
                    [_vm._v("Toggle")]
                  )
                ])
              : _vm.type === "checkbox"
              ? _c("div", { staticClass: "checkbox" }, [
                  _c(
                    "input",
                    _vm._g(
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.localValue,
                            expression: "localValue"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "id_" + (_vm.name || _vm.label.toLowerCase())
                        },
                        domProps: {
                          checked: Array.isArray(_vm.localValue)
                            ? _vm._i(_vm.localValue, null) > -1
                            : _vm.localValue
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.localValue,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.localValue = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.localValue = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.localValue = $$c
                            }
                          }
                        }
                      },
                      Object.assign({}, _vm.$listeners, {
                        input: _vm.updateInverted
                      })
                    )
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      attrs: {
                        for: "id_" + (_vm.name || _vm.label.toLowerCase())
                      }
                    },
                    [_vm._v(_vm._s(_vm.label))]
                  )
                ])
              : _vm.type === "radio"
              ? _c("div", { staticClass: "radio" }, [
                  _vm.label
                    ? _c(
                        "span",
                        { staticClass: "label", class: _vm.labelClasses },
                        [_vm._v(_vm._s(_vm.label))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "options" },
                    _vm._l(_vm.options, function(option) {
                      return _c("div", { key: option, staticClass: "option" }, [
                        _c(
                          "input",
                          _vm._g(
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.localValue,
                                  expression: "localValue"
                                }
                              ],
                              attrs: {
                                type: "radio",
                                id: option,
                                name: _vm.name
                              },
                              domProps: {
                                checked: _vm._q(_vm.localValue, null)
                              },
                              on: {
                                change: function($event) {
                                  _vm.localValue = null
                                }
                              }
                            },
                            Object.assign({}, _vm.$listeners, {
                              input: _vm.update
                            })
                          )
                        ),
                        _vm._v(" "),
                        _c("label", { attrs: { for: option } }, [
                          _vm._v(_vm._s(option))
                        ])
                      ])
                    }),
                    0
                  )
                ])
              : _vm.type === "checkbox"
              ? _c(
                  "input",
                  _vm._g(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localValue,
                          expression: "localValue"
                        }
                      ],
                      staticClass: "text-black bg-transparent",
                      attrs: {
                        disabled: _vm.disabled,
                        id: "id_" + (_vm.name || _vm.label.toLowerCase()),
                        "aria-describedby":
                          "description_" +
                          (_vm.name || _vm.label.toLowerCase()),
                        placeholder: _vm.placeholder || "" + _vm.label,
                        type: "checkbox"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.localValue)
                          ? _vm._i(_vm.localValue, null) > -1
                          : _vm.localValue
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.localValue,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.localValue = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.localValue = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.localValue = $$c
                          }
                        }
                      }
                    },
                    Object.assign({}, _vm.$listeners, { input: _vm.update })
                  )
                )
              : _vm.type === "radio"
              ? _c(
                  "input",
                  _vm._g(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localValue,
                          expression: "localValue"
                        }
                      ],
                      staticClass: "text-black bg-transparent",
                      attrs: {
                        disabled: _vm.disabled,
                        id: "id_" + (_vm.name || _vm.label.toLowerCase()),
                        "aria-describedby":
                          "description_" +
                          (_vm.name || _vm.label.toLowerCase()),
                        placeholder: _vm.placeholder || "" + _vm.label,
                        type: "radio"
                      },
                      domProps: { checked: _vm._q(_vm.localValue, null) },
                      on: {
                        change: function($event) {
                          _vm.localValue = null
                        }
                      }
                    },
                    Object.assign({}, _vm.$listeners, { input: _vm.update })
                  )
                )
              : _c(
                  "input",
                  _vm._g(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localValue,
                          expression: "localValue"
                        }
                      ],
                      staticClass: "text-black bg-transparent",
                      attrs: {
                        disabled: _vm.disabled,
                        id: "id_" + (_vm.name || _vm.label.toLowerCase()),
                        "aria-describedby":
                          "description_" +
                          (_vm.name || _vm.label.toLowerCase()),
                        placeholder: _vm.placeholder || "" + _vm.label,
                        type: _vm.type
                      },
                      domProps: { value: _vm.localValue },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.localValue = $event.target.value
                        }
                      }
                    },
                    Object.assign({}, _vm.$listeners, { input: _vm.update })
                  )
                ),
            _vm._v(" "),
            errors[0]
              ? _c("label", { staticClass: "error" }, [
                  _vm._v(_vm._s(errors[0]))
                ])
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }